// --- La analítica de la web: Umami, la de la propia radio ---
//
// Contrato: `ANALITICA_WEB_INSTRUCCIONES.md` del portal, 13.09.26. La etiqueta
// y la limpieza de direcciones viven en `public/index.html`, en el `<head>`,
// porque tienen que existir antes de la primera página vista. Aquí solo va lo
// que dispara la aplicación: eventos, tipo de cuenta de la visita y la marca
// del personal.
//
// 🔴 **La web nunca falla por la analítica.** Si Umami no ha cargado —un
// bloqueador, un navegador excluido, la red— `window.umami` no existe y todo
// esto no hace nada.
//
// ⛔ **Nunca van en un evento** correo, nombre, teléfono, identificador de
// cuenta ni texto escrito por la persona. Los nombres de artista y de programa
// son públicos y sí pueden ir.

import { IDIOMA } from "@/i18n/idioma";

const LLAVE_EXCLUIDO = "umami.disabled";

/**
 * Espera a que cargue el script, que va con `defer`. Lo que llega antes —el
 * tipo de cuenta de una sesión recuperada al arrancar— se reintenta unos
 * segundos y, si no aparece, se abandona sin ruido.
 */
function cuandoUmami(fn, intentos = 20) {
  if (typeof window === "undefined") return;
  if (window.umami) {
    try {
      fn(window.umami);
    } catch (e) {
      // La analítica no puede romper nada.
    }
    return;
  }
  if (intentos > 0) setTimeout(() => cuandoUmami(fn, intentos - 1), 500);
}

/** Un evento del contrato, con sus propiedades. */
export function medir(evento, propiedades) {
  cuandoUmami((u) => (propiedades ? u.track(evento, propiedades) : u.track(evento)));
}

/** De `cuenta.roles` al valor que pide el contrato. */
function tipoDeCuenta(cuenta) {
  if (!cuenta) return "anonimo";
  const roles = Array.isArray(cuenta.roles) ? cuenta.roles : [];
  const artista = roles.includes("artista");
  const sello = roles.includes("sello");
  if (artista && sello) return "artista+sello";
  if (artista) return "artista";
  if (sello) return "sello";
  return "oyente";
}

/**
 * El tipo de cuenta y el idioma de la visita, **sin identificador**: nunca
 * `umami.identify('<id o correo>')`, que identifica a la persona. El idioma va
 * aquí porque la dirección llega a Umami sin prefijo (`public/index.html`).
 */
export function identificarVisita(cuenta) {
  const tipo_cuenta = tipoDeCuenta(cuenta);
  cuandoUmami((u) => u.identify({ tipo_cuenta, idioma: IDIOMA }));
}

/**
 * Las cuentas del personal marcan su navegador y ya no se miden. **No se quita
 * al cerrar sesión**: el navegador sigue siendo del personal.
 */
export function marcarSiEsInterna(cuenta) {
  if (!cuenta?.interno) return;
  try {
    localStorage.setItem(LLAVE_EXCLUIDO, "1");
  } catch (e) {
    // Sin almacenamiento no hay marca, y no pasa nada más.
  }
}
